import { useEffect } from 'react';
import { navigate } from "@reach/router"

const ProductsPage = () => {
  useEffect(() => {
    navigate('/');
  }, []);
  return null;
};

export default ProductsPage;